/**
 * AiHealthSimplePanel — vista SIMPLE del debug de IA para admin de empresa cliente
 * (Fase 3 de auditoria-agente-ia-diagnostico-automatico). Contraparte de
 * `DebugAssignmentsPanel` (vista técnica, solo equipo Dealider): un semáforo de
 * 3 colores en lenguaje llano, SIN JSON crudo, SIN botón de "copiar para Codex".
 *
 * Datos personales del lead ocultos por defecto (`revelarDatosPersonales=False`
 * en la respuesta del backend) — este panel los muestra solo tras un click
 * explícito en "Mostrar".
 */
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle2, AlertTriangle, XCircle, Eye, EyeOff } from 'lucide-react';

const COLOR_STYLES = {
  verde: { icon: CheckCircle2, text: 'text-emerald-300', bg: 'bg-emerald-400/5', border: 'border-emerald-400/25' },
  amarillo: { icon: AlertTriangle, text: 'text-amber-300', bg: 'bg-amber-400/5', border: 'border-amber-400/25' },
  rojo: { icon: XCircle, text: 'text-red-300', bg: 'bg-red-400/5', border: 'border-red-400/25' },
};

export default function AiHealthSimplePanel({ open, onClose, data }) {
  const [revelado, setRevelado] = useState(false);

  const auditoria = data?.auditoria_ia_simple || { color: 'verde', mensaje: '' };
  const estilo = COLOR_STYLES[auditoria.color] || COLOR_STYLES.verde;
  const Icon = estilo.icon;
  const lead = data?.lead || {};

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose && onClose()}>
      <DialogContent className="max-w-md" data-testid="ai-health-simple-dialog">
        <DialogHeader>
          <DialogTitle>Estado del Agente IA para este lead</DialogTitle>
        </DialogHeader>

        <div className={`rounded-md px-3 py-3 flex items-start gap-2 border ${estilo.bg} ${estilo.border}`}>
          <Icon className={`w-5 h-5 mt-0.5 shrink-0 ${estilo.text}`} />
          <span className={`text-sm ${estilo.text}`}>{auditoria.mensaje}</span>
        </div>

        <div className="mt-3 text-xs text-muted-foreground">
          <div className="flex items-center justify-between">
            <span>Datos del contacto</span>
            <Button
              variant="ghost"
              size="sm"
              className="h-6 px-2 text-[11px]"
              onClick={() => setRevelado((v) => !v)}
              data-testid="ai-health-simple-toggle-pii"
            >
              {revelado ? <EyeOff className="w-3 h-3 mr-1" /> : <Eye className="w-3 h-3 mr-1" />}
              {revelado ? 'Ocultar' : 'Mostrar'}
            </Button>
          </div>
          {revelado ? (
            <div className="mt-1 space-y-0.5">
              <div>Nombre: {lead.name || '—'}</div>
              <div>Teléfono: {lead.phone || '—'}</div>
              <div>Correo: {lead.email || '—'}</div>
            </div>
          ) : (
            <div className="mt-1 text-white/30">Oculto por defecto — click "Mostrar" si lo necesitas.</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
